import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';
import feedaDarkLogo from '../../assets/feedaia-dark-logo.svg';
import logoIcon from '../../assets/logo-icon.svg';

/**
 * Feeda brand mark for light backgrounds (dark wordmark).
 */
export default function BrandLockup({ collapsed = false, className }) {
  return (
    <Link to="/dashboard" className={cn('flex items-center gap-2 min-w-0', className)} aria-label="Feeda">
      {collapsed ? (
        <img src={logoIcon} alt="Feeda" className="h-7 w-7 object-contain" />
      ) : (
        <img src={feedaDarkLogo} alt="Feeda" className="h-7 w-auto max-w-[148px] object-contain object-left" />
      )}
    </Link>
  );
}
